import { Progress, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatPrice } from '../subscription/pricing'
import dayjs from 'dayjs'

type UsageProgressProps = {
    usage?: number
    limit?: number
    /** Counted over the free trial instead of the billing period. */
    trial?: boolean
    /** When the free trial ends, so the customer knows how long it still runs. */
    trialEndsAt?: Date | null
    overageUsage?: number
    overageUnitAmount?: number
}

/**
 * The candidates of the plan used in this billing period (or the free trial), and the extra ones billed.
 */
export function UsageProgress({
    usage = 0,
    limit = 0,
    trial = false,
    trialEndsAt,
    overageUsage = 0,
    overageUnitAmount = 0,
}: UsageProgressProps) {
    const { t } = useTranslation()
    const progressPercentage = limit > 0 ? Math.min(100, Math.round((usage / limit) * 100)) : 0

    return (
        <div className="-my-2">
            <Typography.Text type="secondary">
                {trial
                    ? t('{{usage}} of {{limit}} candidates in your free trial', { usage, limit })
                    : t('{{usage}} of {{limit}} candidates this billing period', { usage, limit })}
                {trial && trialEndsAt && ` · ${t('until {{date}}', { date: dayjs(trialEndsAt).format('D MMMM') })}`}
            </Typography.Text>
            <Progress
                status={progressPercentage === 100 ? 'exception' : 'active'}
                percent={progressPercentage}
            />
            {overageUsage > 0 && (
                <Typography.Text type="warning">
                    {t('{{count}} extra candidates this billing period · {{cost}}', {
                        count: overageUsage,
                        cost: formatPrice(overageUsage * overageUnitAmount, 'EUR'),
                    })}
                </Typography.Text>
            )}
        </div>
    )
}
